export default function Popup({ children }: { children: React.ReactNode }) {
  return (
    <div className="fixed left-0 top-0 z-30 flex h-full w-full flex-col overflow-y-auto bg-slate-500 bg-opacity-90 backdrop-blur-md">
      {children}
    </div>
  );
}
